export default __webpack_public_path__ + "static/media/logo.ea27de44.png";